import { useDispatch, useSelector } from 'react-redux';
import { IRootDispatch, RootState } from '../../../store/models';

export type AppliedDiscountCode = {
  reward_id?: string;
  code: string;
  source: string; // 'referral_123' (from atlantis), 'homepage_toaster_viewed' (like compass)
};
export type AppliedDiscountCodes = AppliedDiscountCode[];

/**
   * Returns a function for applying eligible coupons to the userState model
   * by querying the coupon_eligibility_check route and saving the response's code
   * to the userState model (along with the source of the call), as well as
   * localStorage and the remote state manager (if logged in)
  */
const useApplyDiscountCode = () => {
  const { clientPromotions } = useDispatch<IRootDispatch>();
  const currentState: RootState['userState'] = useSelector<RootState, RootState['userState']>(
    state => state.userState,
  );
  return async (source: string, code?: string, rewardId?: number) => {
    await currentState.hasLoadedPromise;
    return clientPromotions.addDiscountCode({
      discountCode: code,
      source,
      appointmentCost: undefined,
      rewardId,
    });
  };
};

export default useApplyDiscountCode;
